export const mappingData = (list) =>
  list.map((item) => ({ value: item.codigo, label: item.etiqueta }));
export const mappingDataOne = (item) => ({ value: item.codigo, label: item.etiqueta });
export const findData = (list, value) => list.find((item) => item.codigo === value) || {};
